export default __webpack_public_path__ + "static/media/theRooterDoctor.ef170543.jpeg";